import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import { DATATEST } from "constants/integration";

export const List = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} data-test={DATATEST.PROFILE.GRID_VIEW_TYPES.LIST}>
            <path d="M23,3H1C0.4,3,0,3.4,0,4v1c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V4C24,3.4,23.6,3,23,3z" />
            <path d="M23,11H1c-0.6,0-1,0.4-1,1v1c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1v-1C24,11.4,23.6,11,23,11z" />
            <path d="M23,15H1c-0.6,0-1,0.4-1,1v1c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1v-1C24,15.4,23.6,15,23,15z" />
            <path d="M23,19H1c-0.6,0-1,0.4-1,1v1c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1v-1C24,19.4,23.6,19,23,19z" />
            <path d="M23,7H1C0.4,7,0,7.4,0,8v1c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V8C24,7.4,23.6,7,23,7z" />
        </SvgIcon>
    );
};
